import { IReducerAction } from 'src/interfaces/redux';
export * from './contextMenu.selectors';

export interface IContextMenuState {
  isContextMenuVisible: boolean;
  contextMenuPosition: {
    clientX: number;
    clientY: number;
  }
}

export const contextMenuInitialState: IContextMenuState = {
  isContextMenuVisible: false,
  contextMenuPosition: {
    clientX: 0,
    clientY: 0,
  }
};

export enum ContextMenuActionTypes {
  SHOW_CONTEXT_MENU = 'CONTEXT_MENU/SHOW_CONTEXT_MENU',
  HIDE_CONTEXT_MENU = 'CONTEXT_MENU/HIDE_CONTEXT_MENU',
}

export type ContextMenuAction = IReducerAction<ContextMenuActionTypes>;

// eslint-disable-next-line max-len
export default function contextMenuReducer(state: IContextMenuState = contextMenuInitialState, action: ContextMenuAction) {
  switch (action.type) {
    case ContextMenuActionTypes.SHOW_CONTEXT_MENU:
      return { ...state, isContextMenuVisible: true, contextMenuPosition: action.payload };
    case ContextMenuActionTypes.HIDE_CONTEXT_MENU:
      return {
        ...state, isContextMenuVisible: false,
        contextMenuPosition: contextMenuInitialState.contextMenuPosition
      };
    default:
      return state;
  }
}
